// The loading indicator public/index.html shows before the app's code
// arrives (styles live there), drawn again while the app is still starting so
// the page never goes blank between the two.
export function PageLoading() {
  return <div className="page-loading" role="status" aria-label="Loading" />;
}
